import React, { useState, useEffect, useRef } from "react"
import Player from "@vimeo/player"

const VideoPlayer = ({
  videoId,
  videoHash,
  posterSrc,
  posterSrcSet,
  playIconSrc,
}) => {
  const [isOverlayVisible, setIsOverlayVisible] = useState(true)
  const playerContainerRef = useRef(null)
  const [player, setPlayer] = useState(null)
  useEffect(() => {
    const iframe = document.createElement("iframe")
    iframe.setAttribute(
      "src",
      `https://player.vimeo.com/video/${videoId}?h=${videoHash}&badge=0&autopause=0&player_id=0&app_id=58479&controls=1&muted=1&background=0`
    )
    iframe.setAttribute("frameBorder", "0")
    iframe.setAttribute("allow", "autoplay; fullscreen")
    iframe.setAttribute("allowFullScreen", "")
    iframe.style.width = "100%"
    iframe.style.height = "100%"

    playerContainerRef.current.appendChild(iframe)
    const newPlayer = new Player(iframe)
    setPlayer(newPlayer)

    newPlayer.on("ready", () => {
      console.log("Player is ready")
    })

    return () => {
      newPlayer.destroy()
    }
  }, [videoId])
  const handleOverlayClick = () => {
    setIsOverlayVisible(false)
    if (player) {
      player
        .play()
        .catch(error => console.error("Error playing the video:", error))
    }
  }

  return (
    <div className="video-container" onClick={handleOverlayClick}>
      {isOverlayVisible && (
        <div className="video-overlay">
          <img
            src={posterSrc}
            srcset={posterSrcSet}
            alt="Video Cover"
            className="video-poster"
          />

          <svg
            className="play-icon"
            onClick={handleOverlayClick}
            width="70"
            height="70"
            viewBox="0 0 95 95"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1_1682)">
              <path
                d="M47.6541 94.9742C73.8026 94.9742 95.0001 73.7767 95.0001 47.6282C95.0001 21.4797 73.8026 0.282227 47.6541 0.282227C21.5056 0.282227 0.308105 21.4797 0.308105 47.6282C0.308105 73.7767 21.5056 94.9742 47.6541 94.9742Z"
                fill="black"
                fill-opacity="0.75"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M65.7758 47.6282L52.1046 55.5231L38.4453 63.4063V47.6282V31.8502L52.1046 39.7333L65.7758 47.6282Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_1_1682">
                <rect
                  width="94.692"
                  height="94.692"
                  fill="white"
                  transform="translate(0.308105 0.282227)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      )}
      <div className="video-iframe-container" ref={playerContainerRef}></div>
    </div>
  )
}

export default VideoPlayer
